"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createC2DMessage = exports.createD2CMessage = exports.createPartialEncoded = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../date");
exports.NAMESPACE = 'Culligan.Protocol.V3.Prefs';
const createPartialEncoded = (Prefs) => Prefs.pipe(effect_1.Schema.encodedBoundSchema, effect_1.Schema.partialWith({ exact: true }));
exports.createPartialEncoded = createPartialEncoded;
const createD2CMessage = (namespace, Prefs) => {
    const SendPrefs = effect_1.Schema.Struct({
        time: date_1.Timestamp,
        prefs: (0, exports.createPartialEncoded)(Prefs),
    }).annotations({
        identifier: `${namespace}.SendPrefs`,
        title: 'Send',
    });
    return SendPrefs;
};
exports.createD2CMessage = createD2CMessage;
const createC2DMessage = (namespace, Prefs) => {
    const GetPrefs = effect_1.Schema.TaggedStruct('Get', {}).annotations({
        identifier: `${namespace}.GetPrefs`,
        title: 'Get Prefs',
    });
    const PatchPrefs = effect_1.Schema.TaggedStruct('Patch', {
        prefs: (0, exports.createPartialEncoded)(Prefs),
    }).annotations({
        identifier: `${namespace}.PatchPrefs`,
        title: 'Patch Prefs',
    });
    return effect_1.Schema.Union(GetPrefs, PatchPrefs);
};
exports.createC2DMessage = createC2DMessage;
//# sourceMappingURL=prefs.js.map